import { render } from "./AddDepoMessage.vue?vue&type=template&id=6c76a9bc"
import script from "./AddDepoMessage.vue?vue&type=script&lang=js"
export * from "./AddDepoMessage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\murodjon\\Desktop\\admin-uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__